import { type Dispatch, type SetStateAction, useCallback, useState } from 'react'

/**
 * Basically, what this hook does is that, it takes a parameter with value true or false and toggles that value to opposite. It's useful when we want to take some action into it's opposite action, for example: show and hide modal, show more/show less text, open/close side menu.
 * @param {boolean} initialState
 * @returns a tuple with the current toggle state, the toggle function and the setState to create custom toggle functions
 */
export const useToggle = (
  initialState: boolean = false
): [boolean, () => void, Dispatch<SetStateAction<boolean>>] => {
  const [state, setState] = useState(initialState)

  const toggle = useCallback(() => {
    return setState((prevState) => !prevState)
  }, [])

  return [state, toggle, setState]
}
